export const RouterSlugs = {
    SLUG_ALL_CITIES: "all-cities",
    SLUG_FILTERS_END: "all"
};